<template>
  <div>
    <div v-if="item">
      <h4 class="text-info" v-if="item.info_project">
        Проект: {{ item.info_project.title }} / USERID: {{ item.user_id }}
      </h4>

      <h5 class="" v-if="item.shop">
        <Span class="text-danger">Локация:</Span>
        {{ item.shop.name }} / {{ item.shop.address }}
      </h5>
      <h5 class="">
        <Span class="text-danger">Дата создания:</Span>
        {{ item.created_at | dateTimeFormat }}
      </h5>
    
      <h5 class="">
        <Span class="text-danger">Статус:</Span>
        {{ item.state_display }}
      </h5>
      <h5 class="" v-if="item.closed_at">
        <Span class="text-danger">Дата начала обработки:</Span>
        {{ item.start_at | dateTimeFormat }}
      </h5>
      <h5 class="" v-if="item.closed_at">
        <Span class="text-danger">Дата закрытия:</Span>
        {{ item.closed_at | dateTimeFormat }}
      </h5>
      <h5 class="" v-if="item.period">
        <Span class="text-danger">Время обработки (минуты):</Span>
        {{ item.period }} минут
      </h5>
      <h5 class="mb-4">
        <Span class="text-danger">Проблема:</Span> {{ item.name }}
      </h5>
      <h5 class="mb-4" v-if="item.closed_by">
        <Span class="text-danger">Отвественный:</Span> {{ item.closed_by.name }}
      </h5>

      <div v-if="item.model">
        <div>
          <a
            class="link"
            target="_blank"
            :href="`https://cb.retailbox.uz/#/tickets?item_${item.model_type}=${item.model_id}`"
            >Открыть сервис
          </a>
        </div>
        <h4>
          {{ item.model_type }} #
          <b class="text-danger"> {{ item.model_id }}</b>
        </h4>
      </div>

      <chat
        v-model="item.ticket_messages"
        :id="id"
        :refresh="refresh"
        :user_id="item.user_id"
      />

      <div class="border mt-5" v-if="$store.state.user.is_root">
        <fields-list :item="item" :fields="fields" :simple="true" />

        <button class="btn btn-warning btn-icon" @click="updateItem">
          <span class="ti-save"></span>{{ "save" | setText("Сохранить") }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import {
  cardUpdate,
  cardContent,
  toFormData,
  errorNotify,
} from "@/plugins/functions";

export default {
  data: () => ({
    messages: [],
    cardLink: "tickets",
    cardSetLink: "tickets",
    item: null,
    fields: [
      {
        col: " col-12 col-md-12",
        key: "info_project",
        labelKey: "project",
        label: "Выберите проект",
        type: "select",
        modal: "info_project",
        selectKey: "title",
      },
      {
        col: " col-12 col-md-12",
        key: "ticket_rubric",
        labelKey: "category",
        label: "Категория",
        type: "select",
        modal: "ticket_rubric",
        selectKey: "name",
      },
      {
        col: " col-12 col-md-12",
        key: "state",
        label: "Статус",
        labelKey: "status",
        type: "static_radio",
        items: [
          { id: "new", title: "Новый" },
          { id: "proccess", title: "В процессе" },
          { id: "cancel", title: "Отменен" },
          { id: "done", title: "Выполнен" },
        ],
      },
    ],
  }),
  components: {
    chat: () => import("@/components/Chat/index"),
  },
  props: ["id"],
  async created() {
    await this.refresh();
  },

  methods: {
    async refresh() {
      let item = await this.cardContent(this.cardLink, this.id);

      if (item && item.id) {
        this.item = item;
      }
    },
    cardUpdate: cardUpdate,
    cardContent: cardContent,

    async updateItem() {
      let item = await this.cardUpdate(
        this.cardSetLink,
        this.item,
        this.fields
      );

      if (item && item.id) {
        this.item = item;
      }
    },
  },
};
</script>
<style>
</style>
